export default __webpack_public_path__ + "static/media/Major Rune Stone of Ascension (V).80cf758e.jpg";